import React from 'react';
import classNames from 'classnames';

function PromoCodeTermsAndConditionsLinkTemplate ({ modelAttributes, helpers }) {

	const { promoCodeError, SelectedPromoCode } = modelAttributes;

	const { secureSiteURL, showPromoTermsConditions, useDefaultTC } = helpers;

	const pnlCouponOverlayClassName = classNames('hidden', promoCodeError && 'couponErrorOverlay');

	const couponErrorAlign = showPromoTermsConditions ? 'left' : 'center';

	const contactUsHref = `${secureSiteURL}/contact-us/`;

	return (
		<>
			{SelectedPromoCode && (
				<button type="button" className="jsShowPromoCodeTermsAndConditions anchorLink">
					Promo Code Terms &amp; Conditions
				</button>
			)}

			<div id="pnlCouponOverlay" className={pnlCouponOverlayClassName}>
				<div id="couponOuterContainer">
					<table className="couponContainer" cellSpacing="0">
						<tbody>
							{SelectedPromoCode && promoCodeError ? (
								<tr>
									<td id="couponError" valign="middle" align={couponErrorAlign}>
										<div className="couponErrorMessage tal">
											<p>
												{
													'Your coupon code is no longer valid. If you feel this is an error, please '
												}
												<a href={contactUsHref}>contact Customer Service</a>
												{' for assistance.'}
											</p>
											<p className="actionButton tac">
												<button type="button" className="calloutBtn dismissCouponError alt1">
													Dismiss
												</button>
											</p>
										</div>
									</td>
								</tr>
							) : null}
							{SelectedPromoCode && !promoCodeError ? (
								<>
									<tr>
										<td id="couponHdrContainer" width="48%" valign="middle">
											<h1 id="couponHdr">Let the good times begin!</h1>
										</td>
										<td id="couponHdrExt" width="52%" />
									</tr>
									<tr>
										<td id="couponDesc" valign="top">
											<p>
												{'Your coupon code '}
												<strong>
													{SelectedPromoCode}
												</strong>
												{
													' has automatically been entered into your shopping cart. Your discount will be applied upon checkout.'
												}
												<br />
												<br />
												{'Offer Expires: '}
												<span id="endDate" />
											</p>
										</td>
										<td id="couponDescExt" width="50%" />
									</tr>
								</>
							) : null}
							{!SelectedPromoCode ? (
								<>
									<tr>
										<td id="couponHdrContainer" width="48%" valign="middle">
											<h1 id="couponHdr">Coupon General Terms and Conditions</h1>
										</td>
										<td id="couponHdrExt" width="52%" />
									</tr>
									<tr>
										<td id="couponDesc" valign="top" />
										<td id="couponDescExt" width="50%" />
									</tr>
								</>
							) : null}
						</tbody>
					</table>
					{showPromoTermsConditions && (
						<div id="couponTermsContainer">
							<div id="couponTerms">
								<table
									border="0"
									width="340"
									cellPadding="10"
									cellSpacing="0"
									align="center"
									className="border2"
									id="Table1"
								>
									<tbody>
										<tr>
											<td id="couponSmallPrintContainer">
												<div name="terms" id="couponSmallPrint">
													{useDefaultTC && (
														<>
															Coupon General Terms and Conditions - Many LAMPS PLUS
															coupons have a minimum purchase requirement that excludes
															shipping and applicable taxes in order to receive the
															specific coupon discount or offer. Coupons are valid only on
															regular priced, in-stock merchandise only; they are not
															valid on special orders or previous orders, on sale items,
															mark-downs, clearance center items, and they may not be
															combined with any other coupons or discounts. One coupon per
															customer, one time use only. Offers are non-transferable and
															not redeemable for cash or gift certificates. Free shipping
															offers exclude items requiring freight shipping. In ceiling
															fan category, valid only on Casa Vieja, John Timberland, and
															Possini Euro Design brands. Not valid on the following
															brands: Access, Anolon, Ambience, Artcraft, Arteriors Home,
															BergHOFF, Besa, Bluworld, BonJour, Butler, Cake Boss,
															Capital Lighting, Casablanca, Circulon, Concord, Cooper
															Classics, Corbett, Craftmade, Crystorama, CSL, Currey and
															Company, Dale Tiffany, Deco Breeze, Designers Fountain,
															Dimplex, Emerson, ET2, Eurofase, Fanimation, Farberware,
															Fine Art Lamps, Flambeau Lighting, George Kovacs, Global
															Product Resources, Inc., Gold Crest, Golden Lighting,
															Hinkley Lighting, Holtkoetter, House of Troy, Howard Elliot,
															Hubbarton Forge, Hudson Valley, Hunter, Jezebel, John
															Richard, Jonathan Adler, Justice Design, Kenroy Home,
															Kichler, Kimball &amp; Young, Lite Source, Mario Industries,
															Mathews Fan Company, Maxim, Mele and Company, Metropolitan,
															Meyer Corporation, Minka Aire, Minka Lavery, Modern Fan,
															Monte Carlo, Murray Feiss, Nambe, Nathan Direct, PLC,
															Progress Lighting, Pure Country Weavers, QualArc, Quoizel,
															Quorum, Rachael Ray, Reed and Barton, Robert Abbey, Robert
															Sonneman, Savoy House, Schonbek, Silverstone, Tech Lighting,
															Thomas Lighting, Thumbprints, Troy, Uttermost, Varaluz,
															Vaxcel, WAC In the event of a return that lowers the total
															purchase amount below the coupon's minimum purchase
															requirement, the coupon savings amount may be deducted from
															your refund. Other restrictions may apply; see your specific
															coupon for exact terms and expiration dates.
														</>
													)}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);

}

export default PromoCodeTermsAndConditionsLinkTemplate;
